import { PawPrint, BadgeCheck, Heart } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const verifiedShelters = [
  "Piotrków Trybunalski",
  "Stargard",
  "Chełm",
  "Milanówek",
  "Rzezawa",
  "Hajnówka",
  "Sokółka",
  "Szumowo",
];

export const InstagramStoryVerified3 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image as element for better html-to-image compatibility on iOS */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />
      {/* Decorative circles */}
      <div
        style={{
          position: "absolute",
          top: "-100px",
          right: "-100px",
          width: "400px",
          height: "400px",
          borderRadius: "50%",
          background: "rgba(78,138,110,0.1)",
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-150px",
          left: "-100px",
          width: "500px",
          height: "500px",
          borderRadius: "50%",
          background: "rgba(78,138,110,0.08)",
          zIndex: 1,
        }}
      />

      {/* Safe zone content - 250px margins */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 80px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Big number header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              fontSize: "200px",
              fontWeight: 800,
              color: "#4E8A6E",
              lineHeight: 0.9,
              textShadow: "0 8px 32px rgba(78,138,110,0.2)",
            }}
          >
            8
          </div>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "12px",
              marginTop: "-16px",
            }}
          >
            <BadgeCheck style={{ width: "44px", height: "44px", color: "#4E8A6E" }} />
            <span
              style={{
                fontSize: "44px",
                fontWeight: 800,
                color: "#2D5A3D",
              }}
            >
              Zweryfikowanych
            </span>
          </div>
        </div>

        {/* Shelters as timeline */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            paddingLeft: "60px",
          }}
        >
          {/* Vertical line */}
          <div
            style={{
              position: "absolute",
              left: "20px",
              top: "20px",
              bottom: "20px",
              width: "4px",
              background: "linear-gradient(180deg, #4E8A6E 0%, #6BAF8D 100%)",
              borderRadius: "2px",
            }}
          />

          {verifiedShelters.map((city, i) => (
            <div
              key={i}
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                position: "relative",
              }}
            >
              {/* Dot */}
              <div
                style={{
                  position: "absolute",
                  left: "-52px",
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  background: "#4E8A6E",
                  border: "4px solid #FFFFFF",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              />
              
              <div
                style={{
                  background: "rgba(255,255,255,0.95)",
                  borderRadius: "16px",
                  padding: "18px 28px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                  width: "100%",
                }}
              >
                <span style={{ fontSize: "30px", fontWeight: 700, color: "#2D5A3D" }}>
                  📍 {city}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom section */}
        <div
          style={{
            textAlign: "center",
            marginTop: "32px",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              background: "rgba(78,138,110,0.1)",
              borderRadius: "100px",
              padding: "16px 32px",
              marginBottom: "24px",
            }}
          >
            <Heart style={{ width: "28px", height: "28px", color: "#E57373", fill: "#E57373" }} />
            <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>
              Sprawdź ich potrzeby i pomóż!
            </span>
          </div>

          {/* Logo */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "44px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "30px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
